(() => {
  const copyUrl = async (button) => {
    const url = button.dataset.ktCopyUrl || window.location.href;
    const status = button.closest('.kt-share')?.querySelector('[data-kt-copy-status]');

    try {
      await navigator.clipboard.writeText(url);
    } catch (error) {
      const input = document.createElement('textarea');
      input.value = url;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      input.remove();
    }

    if (status) status.textContent = 'Enlace copiado';
  };

  const initCarousel = (carousel) => {
    const viewport = carousel.querySelector('[data-kt-carousel-viewport]');
    const slides = Array.from(carousel.querySelectorAll('[data-kt-carousel-slide]'));
    const controls = carousel.querySelector('[data-kt-carousel-controls]');
    const previous = carousel.querySelector('[data-kt-carousel-previous]');
    const next = carousel.querySelector('[data-kt-carousel-next]');
    const current = carousel.querySelector('[data-kt-carousel-current]');
    const total = carousel.querySelector('[data-kt-carousel-total]');

    if (!viewport || slides.length === 0) return;

    let activeIndex = 0;
    let frame;

    const update = () => {
      activeIndex = slides.reduce((closestIndex, slide, index) => {
        const closestDistance = Math.abs(slides[closestIndex].offsetLeft - viewport.scrollLeft);
        const distance = Math.abs(slide.offsetLeft - viewport.scrollLeft);
        return distance < closestDistance ? index : closestIndex;
      }, 0);

      if (current) current.textContent = String(activeIndex + 1);
      if (previous) previous.disabled = activeIndex === 0;
      if (next) next.disabled = activeIndex === slides.length - 1;
    };

    const goTo = (index) => {
      const target = Math.max(0, Math.min(index, slides.length - 1));
      viewport.scrollTo({ left: slides[target].offsetLeft, behavior: 'smooth' });
    };

    if (total) total.textContent = String(slides.length);
    if (controls && slides.length > 1) controls.hidden = false;
    if (previous) previous.addEventListener('click', () => goTo(activeIndex - 1));
    if (next) next.addEventListener('click', () => goTo(activeIndex + 1));

    viewport.addEventListener(
      'scroll',
      () => {
        window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(update);
      },
      { passive: true }
    );

    viewport.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        goTo(activeIndex - 1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        goTo(activeIndex + 1);
      }
    });

    update();
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-kt-copy-url]').forEach((button) => {
      if (button.dataset.ktCopyReady) return;
      button.dataset.ktCopyReady = 'true';
      button.addEventListener('click', () => copyUrl(button));
    });

    root.querySelectorAll('[data-kt-carousel]').forEach((carousel) => {
      if (carousel.dataset.ktCarouselReady) return;
      carousel.dataset.ktCarouselReady = 'true';
      initCarousel(carousel);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
